module.exports = __webpack_public_path__ + "static/img/desc_icon3.09037609.png";